import axios from 'axios';
import router from './router/index';
import {encrypt} from './js/common';
import { Loading,Message} from "element-ui";
let loading = null;    //设置全局变量loading
axios.defaults.baseURL = '/api'
 // let base = process.env.NODE_ENV=="production"? 'http://localhost:54514/':'';
let base = process.env.NODE_ENV=="production"? 'http://apps.shibakefu.com/':'';
axios.create({
    withCredentials:true   //加了这段就可以跨域了 
    });
// 请求延时
axios.defaults.timeout =-1;

axios.interceptors.request.use(
    config => {
		if(!config.params)
			config.params={};
		if(!loading&&!config.params.ElementLoading){
     loading=  Loading.service({
           lock: true,   //是否锁定屏幕的滚动
           text: `正在${config.method!='get'?'处理':'加载'}数据中...`,   //loading下面的文字
           background: "hsla(0,0%,100%,.95);",   //loading的背景色
		      spinner: ' el-icon-loading', 
			     // spinner: ' el-icon-magic-stick', 
			 customClass:'f50',
           target:"body"    //loading显示在容器
         });
		 }
		  config.headers["Content-Type"]='application/json';
		  config.headers["sign"]=encrypt(new Date().getTime().toString())
        config.url=base+config.url;
            config.headers['Authorization'] = "Bearer " +localStorage.getItem('TOKEN');
		config.headers['Access-Control-Allow-Origin']= '*';
		config.headers['mpv']= '1.25';
		config.headers['platform']= 'mp';
		config.headers['ids']= localStorage.getItem('SELECTIDS')||'';
		  config.headers['Access-Control-Allow-Headers']='*';
		  config.headers['Access-Control-Allow-Methods']= 'GET, POST, PUT, DELETE, OPTIONS';
        return config;
    }, 
    error => {
		loading.close();
		loading=null;
        return Promise.reject(error);
    }
);

// http response 拦截器
axios.interceptors.response.use(
    response => {
			if(loading){
				loading.close();
				loading=null;
			}
        if(typeof response.data=='string'){
            response.data=JSON.parse(response.data);
        }
        if(response.data.status>200){
			Message.error(response.data.data||response.data.message||'服务器处理异常')
             return Promise.reject(response.data);
        }  
   localStorage.removeItem('id')
   if(response.config&&response.config.method=='get')
       return response.data.data;
		return  response.data;
    },
    error => {
		if(loading){
			loading.close();
			loading=null;
		}
         if(error.response&&error.response.status!=401){
			Message.error(error.response.statusText||error.response.message)
           return Promise.reject(error.response);
        }else if (error.response&&error.response.status == 401) { 
			Message.error('登录信息已经过期')
            router.replace({
                path: "/login"
            });
            window.location.reload()
        }
         return Promise.reject(error.response);
    }
);

